/**
 * The identity a recording belongs to, as one comparable string.
 *
 * Computed in one place because it is written to disk by the recorder and read back by the
 * recovery scan; two spellings that drift apart would silently stop offering people their own
 * recordings, and the symptom — nothing happens — names nothing.
 *
 * @param orgId - The active organisation.
 * @param userId - The signed-in user.
 * @returns The owner key stored alongside a recording.
 */
export function recordingOwner(orgId: string, userId: string) {
	return `${orgId}:${userId}`;
}
